import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ShieldOff } from 'lucide-react'
import { getDefaultHomePath } from '../../utils/routeAccess'
import { usePermissions } from '../../hooks/usePermissions'

export default function AccesoDenegado() {
  const location = useLocation()
  const { permissions } = usePermissions()
  const homePath = permissions ? getDefaultHomePath(permissions) : '/dashboard'

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 text-center">
      <ShieldOff className="w-16 h-16 text-amber-500 mb-4" aria-hidden />
      <h1 className="text-2xl font-semibold text-white mb-2">Acceso no permitido</h1>
      <p className="text-gray-400 max-w-md mb-6">
        No tienes permisos para ver esta página
        {location.state?.from ? (
          <>
            {' '}
            (
            <code className="text-sm text-gray-500">{location.state.from}</code>
            )
          </>
        ) : null}
        . Contacta con tu responsable si crees que es un error.
      </p>
      <Link
        to={{ pathname: homePath, search: location.search }}
        className="inline-flex items-center px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-medium hover:bg-blue-500 transition-colors"
      >
        Ir a mi área permitida
      </Link>
    </div>
  )
}

